export default {
  path: 'patrol-service/settings/subscriptions',
  name: 'PatrolSubscriptionSettings',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/PatrolSubscriptionSettingsIndex.vue')
}
